var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { "data-vv-scope": "step-2-part-1" } }, [
      _c("div", { staticClass: "row mb-5" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("list-user-groups", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: _vm.userGroupsState.list.length > 1 },
                  expression: "{ required: userGroupsState.list.length > 1 }"
                }
              ],
              ref: "creatorGroup",
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                "only-groups": "",
                label: "Grupo al que irá asociado el expediente (*)",
                name: "creatorGroup",
                danger: _vm.errors.has("step-2-part-1.creatorGroup"),
                "danger-text": _vm.errors.first("step-2-part-1.creatorGroup")
              },
              model: {
                value: _vm.step.creatorGroup,
                callback: function($$v) {
                  _vm.$set(_vm.step, "creatorGroup", $$v)
                },
                expression: "step.creatorGroup"
              }
            })
          ],
          1
        )
      ]),
      !_vm.isNumerationFile
        ? _c("div", { staticClass: "row mb-3" }, [_vm._m(1)])
        : _vm._e(),
      !_vm.isNumerationFile
        ? _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("list-groups", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  ref: "directionId",
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Dirección - Región",
                    name: "directionId",
                    danger: _vm.errors.has("step-2-part-1.directionId"),
                    "danger-text": _vm.errors.first("step-2-part-1.directionId")
                  },
                  model: {
                    value: _vm.step.directionId,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "directionId", $$v)
                    },
                    expression: "step.directionId"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("vs-input", {
              staticClass: "w-100",
              attrs: {
                label: "Cargo Persona",
                maxlength: "150",
                name: "personPosition"
              },
              model: {
                value: _vm.step.personPosition,
                callback: function($$v) {
                  _vm.$set(_vm.step, "personPosition", $$v)
                },
                expression: "step.personPosition"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
      ])
    ]),
    _c(
      "form",
      { attrs: { "data-vv-scope": "step-2-part-2" } },
      [
        _vm._m(2),
        _c("SelectSubject", {
          attrs: {
            docTypeSelected: _vm.documentTypeSelected,
            scope: "step-2-part-2"
          },
          on: {
            "add-subject": _vm.addSubject,
            "clear-sanitaries": _vm.clearSanitaries,
            "clear-doc-digital": _vm.clearDocDigital
          }
        }),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _vm.step.subjects
                ? _c("TableSubjects", {
                    attrs: { subjects: _vm.step.subjects },
                    model: {
                      value: _vm.step.subjectsSelected,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "subjectsSelected", $$v)
                      },
                      expression: "step.subjectsSelected"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ],
      1
    ),
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
    ]),
    _c(
      "form",
      { attrs: { "data-vv-scope": "step-2-part-3" } },
      [
        _vm._m(3),
        _c("SelectCopy", {
          attrs: { scope: "step-2-part-3" },
          on: {
            "add-copy": _vm.addCopy,
            "clear-copies-doc-digital": _vm.clearCopiesDocDigital
          }
        }),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("TableCopies", {
                attrs: { copies: _vm.step.copies },
                model: {
                  value: _vm.step.copiesSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "copiesSelected", $$v)
                  },
                  expression: "step.copiesSelected"
                }
              })
            ],
            1
          )
        ])
      ],
      1
    ),
    _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
    ]),
    _c("form", { attrs: { "data-vv-scope": "step-2-part-4" } }, [
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "vs-select",
              {
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Acompaña Físico",
                  name: "esFisico"
                },
                model: {
                  value: _vm.step.withAttachment,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "withAttachment", $$v)
                  },
                  expression: "step.withAttachment"
                }
              },
              [
                _c("vs-select-item", { attrs: { value: 0, text: "No" } }),
                _c("vs-select-item", { attrs: { value: 1, text: "Si" } })
              ],
              1
            )
          ],
          1
        ),
        _vm.step.withAttachment
          ? _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: _vm.step.withAttachment === 1 },
                      expression: "{ required: step.withAttachment === 1 }"
                    }
                  ],
                  staticClass: "w-100",
                  attrs: {
                    label: "Detalle",
                    maxlength: "250",
                    name: "documentDetail",
                    danger: _vm.errors.has("step-2-part-4.documentDetail"),
                    "danger-text": _vm.errors.first(
                      "step-2-part-4.documentDetail"
                    )
                  },
                  model: {
                    value: _vm.step.documentDetail,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "documentDetail", $$v)
                    },
                    expression: "step.documentDetail"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("vs-input", {
              staticClass: "w-100",
              attrs: {
                label: "Resumen materia",
                maxlength: "250",
                name: "resumen"
              },
              model: {
                value: _vm.step.resumen,
                callback: function($$v) {
                  _vm.$set(_vm.step, "resumen", $$v)
                },
                expression: "step.resumen"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("label", { attrs: { for: "observation" } }, [
              _vm._v("Observacion (5000 caracteres)")
            ]),
            _c("vs-textarea", {
              attrs: {
                id: "observation",
                maxlength: "5000",
                label: "Observacion (5000 caracteres)",
                name: "observacion",
                width: "100%",
                height: "100px"
              },
              model: {
                value: _vm.step.observation,
                callback: function($$v) {
                  _vm.$set(_vm.step, "observation", $$v)
                },
                expression: "step.observation"
              }
            })
          ],
          1
        )
      ]),
      _vm.error.message !== ""
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to text-right",
              staticStyle: { height: "32px" }
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.error.message) + " ")
              ])
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Datos de la persona que ingresa el documento")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Origen / Datos Remitente")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Destinatario (*)")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [_c("h4", [_vm._v("Con copia a")])])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }